import styled from 'styled-components'

export const StoreContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  background-color: ${props => props.theme.colors.background.secondary};
`

export const StoreImage = styled.img`
  width: ${props => props.theme.size.S};
  height: ${props => props.theme.size.S};
  object-fit: contain;
  aspect-ratio: 1/1;
`
export const StoreLabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`
